import api from './api';

const permissionsApi = {
  // Vérifier accès à une page
  checkAccess: (page) => {
    return api.get(`/permissions/check/${page}`);
  },

  // Pages accessibles à l'utilisateur courant (pour les sélecteurs)
  getMyPages: () => {
    return api.get('/permissions/my-pages');
  },

  // Pages qu'un délégué de plaque ne peut pas attribuer (2026-11-03)
  getDelegation: () => api.get('/permissions/delegation'),

  // Pages par plaque (2026-10-26) : { plaques, fermees: [{ plaque_id, page }] }
  getPlaquesPages: () => api.get('/permissions/plaques-pages'),
  setPlaquePage: (plaque_id, page, disponible) => api.put('/permissions/plaques-pages', { plaque_id, page, disponible }),

  // Masquage d'une page sur un compte super-administrateur
  masquer:   (page, userId) => api.post(`/permissions/${page}/masquer`, { user_id: userId }),
  demasquer: (page, userId) => api.delete(`/permissions/${page}/masquer/${userId}`),

  // Liste des utilisateurs avec permissions pour une page
  getPagePermissions: (page) => {
    return api.get(`/permissions/${page}`);
  },

  // Accorder permissions
  grant: (page, data) => {
    return api.post(`/permissions/${page}/grant`, data);
  },

  // Modifier permissions
  update: (id, data) => {
    return api.put(`/permissions/${id}`, data);
  },

  // Révoquer permissions
  revoke: (page, userId) => {
    return api.delete(`/permissions/${page}/revoke/${userId}`);
  },

  // Toutes les permissions d'un utilisateur
  getUserPermissions: (userId) => {
    return api.get(`/permissions/by-user/${userId}`);
  }
};

export default permissionsApi;
